import "leaflet-routing-machine/dist/leaflet-routing-machine.css"
import "leaflet-routing-machine"
import { useMap } from "react-leaflet"
import { useEffect } from "react"
import L from 'leaflet'

function Routing({userLocation, targetLocation}) {
    console.log('userLocation', userLocation);
    console.log('targetLocation', targetLocation);

    if(typeof targetLocation == 'undefined'){
        targetLocation = userLocation
    }
    const map = useMap()
    useEffect(()=>{
        if(!map) return;

        const routingControl = L.Routing.control({
            waypoints: [L.latLng(userLocation[0], userLocation[1]), L.latLng(targetLocation[0], targetLocation[1])],
            lineOptions: {
              styles: [
                {
                  color: "blue",
                  opacity: 0.6,
                  weight: 4
                }
              ]
            },
            routeWhileDragging: true
            
          }).addTo(map);

        return () => map.removeControl(routingControl)
    }, [map])
}

export default Routing